<template>

    <span v-tooltip="tooltipConfig" class="badge d-flex gap-1 align-items-center w-fit-content" :class="badgeClasses">
        <i v-if="icon" :class="icon" :style="styleIcon"></i>
        <span>{{ text }}</span>
    </span>

</template>

<script>
export default {
    props: {
        text: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            default: 'info',
        },
        unread: {
            type: Boolean,
            default: false,
        },
        rounded: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: String
        },
        iconColor: {
            type: String
        },
        tooltip: {
            type: String
        },
        totooltipPlacement:{
            type: String,
            default: 'top'
        }
    },
    data() {
        return {
            senhaVisivel: false,
        };
    },
    computed: {
        badgeClasses() {

            return {
                'badge-soft-info': this.type == 'info',
                'badge-soft-danger': this.type == 'danger',
                'badge-soft-success': this.type == 'success',
                'badge-soft-warning': this.type == 'warning',
                'badge-soft-light': this.type == 'light',
                'unread_count': this.unread,
                'rounded-pill': this.rounded
            };

        },
        tooltipConfig(){
            return {content: this.tooltip, placement: this.totooltipPlacement}
        }, 
        styleIcon(){
            return {color: this.iconColor}
        }
    },
    methods: {
    },
};
</script>